export function PhoneReminderFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14 2a2 2 0 012-2h1.586c.51 0 1.1.201 1.485.725.416.566.89 1.444 1.261 2.437.372.994.668 2.174.668 3.338 0 1.164-.296 2.344-.668 3.338-.371.993-.845 1.87-1.26 2.437-.386.524-.976.725-1.486.725H16a2 2 0 01-2-2V9a2 2 0 012-2V6a2 2 0 01-2-2V2zm3.524 0H16v2a2 2 0 012 2v1a2 2 0 01-2 2v2h1.524c.279-.404.638-1.07.935-1.863.32-.856.541-1.79.541-2.637 0-.848-.22-1.781-.54-2.637-.298-.793-.657-1.459-.936-1.863zM12 2c.35 0 .687.06 1 .17V12a2 2 0 002 2h4a1.99 1.99 0 001.09-.323l.91.909c1.26 1.26.367 3.414-1.414 3.414H15a3 3 0 01-6 0H4.414C2.632 18 1.74 15.846 3 14.586l2.093-2.093.052-.21c.076-.302.187-.722.325-1.197.272-.93.669-2.133 1.142-3.046.43-.828 1.1-1.761 1.635-2.458.272-.355.52-.662.699-.88l.08-.097A3 3 0 0112 2z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
